module.exports = __webpack_public_path__ + "static/img/writingjapaneseanimal_25_optimized.665927c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/page/writingjapaneseanimal_25_optimized.jpg
// module id = LY+s
// module chunks = 0